<template>
  <div class="gonggaoList">
    <div class="contentList">
      <div class="everyList" v-for="item in noticeList" :key="item.id">
        <div class="yearTitle">{{ item.year }}</div>
        <div class="inList" v-for="item1 in item.list" :key="item1.id">
          <div class="listHead">
            <div class="yuanDian"></div>
            <div class="time">
              <div class="date">
                {{ item1.starttime | filterMonth
                }}{{ item1.starttime | filterDate }}
              </div>
              <div class="shike">
                {{ item1.starttime | filterHours
                }}{{ item1.starttime | filterMinutes }}
              </div>
            </div>
          </div>
          <div class="listWord">
            <div class="word" @click="goDetail(item1.id, item1.url)">
              {{ item1.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import qs from "qs";
import { Dialog } from "vant";
import { Toast } from "vant";

export default {
  mounted() {
    this.getNoticeList();
    this.getHeight();
    // this.getToken()

    document.querySelector("body").setAttribute("style", "overflow:hidden;");
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto;");
  },
  data() {
    return {
      noticeList: [],
    };
  },
  filters: {
    filterMonth: function (value) {
      return value.substring(5, 7) + "月";
    },
    filterDate: function (value) {
      return value.substring(8, 10) + "日";
    },
    filterHours: function (value) {
      return value.substring(11, 13);
    },
    filterMinutes: function (value) {
      return value.substring(13, 16);
    },
  },
  methods: {
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".contentList").offsetTop -
        document.documentElement.scrollTop;

      document.querySelector(".contentList ").style.height = a - b + "px";
    },
    getNoticeList() {
      this.$toast.loading({
        message: "数据加载中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "HOMENOTICE",
      });
      this.$axios
        .post("appapi/app/cmsInterface/getCmsInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            console.log(res);
            res.data.data.forEach((item) => {
              Toast.clear();
              console.log(item);
              this.noticeList.push(item);
              // let dateTime = new Date(item.list.starttime);
              // let year = dateTime.getFullYear();
              // console.log(year);
              // let now = new Date();
              // let nowyear = now.getFullYear();
              // console.log(nowyear);
              // this.noticeList.push(item);
            });
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    goDetail(NewsId, url) {
      // console.log('GonggaoListDetail', )

      // return;
      // let src = "";
      // if (url && url != "") {
      //   src = url;
      // } else {
      //   src =
      //     this.$router.resolve("GonggaoListDetail").href;
      // }
      // this.$router.push({
      //   name: "NewPage",
      //   params: {
      //     NewsId
      //   },
      // });
      this.$router.push({
        name: "GonggaoListDetail",
        query: {
          NewsId,
        },
      });
    },
    getToken() {
      let token = this.$route.query.token;
      if (!token == "") {
        localStorage.setItem("token", token);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gonggaoList {
  width: 100%;
  height: auto;
  background-image: url("../assets/images/gonggaobg.png");
  background-repeat: no-repeat;
  background-size: contain;

  padding: 2.875rem 2rem;
  background-color: #eef4f6;

  .title {
    text-align: center;
    color: #ffffff;
    font-size: 2.25rem;
  }

  .contentList {
    background-color: #fff;
    border-radius: 1rem;
    padding: 3rem 2.25rem;
    margin-top: 1.625rem;
    overflow: auto;
    padding-bottom: 12.5rem;

    .yearTitle {
      font-size: 3.75rem;
      color: #19212a;
    }
    .inList {
      margin-top: 2.75rem;
    }
    .listHead {
      display: flex;
      align-items: center;
      .yuanDian {
        width: 1.25rem;
        height: 1.25rem;
        background: #338989;
        border-radius: 100px;
      }
      .time {
        display: flex;
        margin-left: 1.25rem;
        background: #eef4f6;
        border-radius: 1.75rem;
        width: 16.75rem;
        height: 3.5rem;
        line-height: 3.5rem;
        .date {
          font-size: 1.875rem;
          margin-left: 1.375rem;
          color: #19212a;
        }
        .shike {
          margin-left: 1.125rem;
          font-size: 1.5rem;
          color: #878787;
        }
      }
    }
    .listWord {
      display: flex;
      border-left: 3px solid rgba(51, 137, 137, 0.5);
      margin-left: 0.5rem;

      .shuxian {
        margin-left: 0.5rem;
        width: 0.375rem;
        background: rgba(51, 137, 137, 0.5);
      }
      .word {
        color: #19212a;
        font-size: 2.125rem;
        padding-top: 1.625rem;
        padding-left: 2.5rem;
        padding-bottom: 3.75rem;
        line-height: 3.125rem;
        letter-spacing: 0.5px;
      }
    }
  }
}
</style>